/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberCategories } from '../../models/member-categories';

export interface GetAllMemberCategoriesInternalV2MembersCategoriesAllGet$Params {
  org: string;
}

export function getAllMemberCategoriesInternalV2MembersCategoriesAllGet(http: HttpClient, rootUrl: string, params: GetAllMemberCategoriesInternalV2MembersCategoriesAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberCategories>>> {
  const rb = new RequestBuilder(rootUrl, getAllMemberCategoriesInternalV2MembersCategoriesAllGet.PATH, 'get');
  if (params) {
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MemberCategories>>;
    })
  );
}

getAllMemberCategoriesInternalV2MembersCategoriesAllGet.PATH = '/_internal/v2/members/categories/all';
